import { render } from "./signature.vue?vue&type=template&id=5d2c1d18"
import script from "./signature.vue?vue&type=script&lang=js"
export * from "./signature.vue?vue&type=script&lang=js"

import "./signature.vue?vue&type=style&index=0&id=5d2c1d18&lang=css"

import exportComponent from "/builds/advocacy/e-advokat-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__